// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__27d5a"};